import type { Locale } from "../i18n";

export interface AppLinksEnv {
  VITE_SUPPORT_EMAIL?: string;
  VITE_FEEDBACK_URL_RU?: string;
  VITE_FEEDBACK_URL_EN?: string;
}

export interface AppLinks {
  supportEmail: string;
  feedbackUrls: Record<Locale, string>;
}

const DEFAULT_LINKS: AppLinks = {
  supportEmail: "ivan.senishin@gmail.com",
  feedbackUrls: {
    ru: "https://tally.so/r/D486Gj",
    en: "https://tally.so/r/lbGkEp",
  },
};

function envValue(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : fallback;
}

/**
 * Public contact and feedback-form links shown in Settings. Build-time env
 * overrides the defaults so a staging build can point at test forms; blank
 * values fall back to the published defaults.
 */
export function resolveAppLinks(env: AppLinksEnv): AppLinks {
  return {
    supportEmail: envValue(env.VITE_SUPPORT_EMAIL, DEFAULT_LINKS.supportEmail),
    feedbackUrls: {
      ru: envValue(env.VITE_FEEDBACK_URL_RU, DEFAULT_LINKS.feedbackUrls.ru),
      en: envValue(env.VITE_FEEDBACK_URL_EN, DEFAULT_LINKS.feedbackUrls.en),
    },
  };
}

export function feedbackFormUrl(links: AppLinks, locale: Locale): string {
  return links.feedbackUrls[locale];
}

export const appLinks: AppLinks = resolveAppLinks(import.meta.env);

export const appVersion: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
